import * as React from "react";
import { withFetch } from "./fetch";
import dataLayer from "./dataLayer";

function getCookie(name) {
  var matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + "=([^;]*)"
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function logCrash(fetch) {
  return json => {
   let log = {...json};
   const userId = getCookie("user_id");
   log.user_id = userId && parseInt(userId, 10);
   log.user_key = getCookie("user_key");
   if (log.error && log.error.info) {
     log.error.info.user_agent = window.navigator.userAgent;
   } else {
     log.error = {
       info: {
         user_agent: window.navigator.userAgent
       }
     };
   }

   if (process.env.NODE_ENV === "development") {
     console.warn(log);
     return null;
   }

   dataLayer({
     event: "exception-to-ga",
     exDescription: JSON.stringify(log),
     exFatal: true
   });

   return fetch(`crashlog://log`, {
     method: "POST",
     headers: {
       "Accept": "application/json",
       "Content-Type": "application/json"
     },
     body: JSON.stringify(log)
   });
  }
};

function withCrashLog(Component) {
  function CrashLog(props) {
    const crashLog = logCrash(props.fetch);
    return <Component {...props} crashLog={crashLog} />;
  }

  return withFetch(CrashLog);
};

export default withCrashLog;



// WEBPACK FOOTER //
// ./src/components/common/crashLog.js